export * from './profiles.component';


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/profiles/index.ts